import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ChannelHintBox from "@/components/Member/ChannelHintBox";
import { MemberPageHeader } from "@/components/Member/MemberPageHeader";
import { MemberPageLayout } from "@/components/Member/MemberPageLayout";
import useKakaoSignInUp from "@/components/Member/hooks/useKakaoSignInUp";
import Icon from "@/components/icon/Icon";
import { ArrowRight, Sizes } from "@/components/icon/IconList";
import { SignIn } from "@/components/signIn/SignInComponents";
import useRedirect from "@/hooks/useRedirect";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { REGISTRATION_PAGE } from "@/settings/constant";
import { ConfirmDialog } from "@bookips/sds";
import { Button } from "@bookips/solvook-ui-library";
import { Divider, Typography, styled as muiStyled, useTheme } from "@mui/material";
import LoginDialog from "src/store/loginDialog";
const LoginNextPage = ()=>{
    const theme = useTheme();
    const { isDesktop  } = useWindowDimensions();
    const { onKakao  } = useKakaoSignInUp();
    const { redirectPath , redirectAgain  } = useRedirect();
    let isPartnerLogin = false;
    if (typeof redirectPath === "string" && redirectPath.startsWith("http")) {
        const destinationDomain = new URL(redirectPath);
        isPartnerLogin = destinationDomain.origin === process.env.NEXT_PUBLIC_PARTNER_URL;
    }
    const { isOpenSignUpDialog , openSignUpDialogContents , setState  } = LoginDialog((state)=>({
            isOpenSignUpDialog: state.isOpenSignUpDialog,
            openSignUpDialogContents: state.openSignUpDialogContents,
            setState: state.setState
        })) //회원가입, 로그인시 다이얼로그 store
    ;
    return /*#__PURE__*/ _jsxs(LoginNextPageWrapper, {
        children: [
            !isDesktop ? /*#__PURE__*/ _jsx(MemberPageHeader, {
                pageTitle: "로그인",
                showBackButton: true
            }) : /*#__PURE__*/ _jsx(MemberPageHeader, {
                showLogo: true
            }),
            /*#__PURE__*/ _jsxs(SignIn, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "bold28",
                        sx: {
                            textAlign: "center"
                        },
                        children: !isPartnerLogin ? /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                "쏠북에 다시 오신걸",
                                /*#__PURE__*/ _jsx("br", {}),
                                " 환영합니다!"
                            ]
                        }) : /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                "쏠북 저자센터",
                                /*#__PURE__*/ _jsx("br", {}),
                                "로그인"
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs(InnerBox, {
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "sing-in-btn-box",
                                children: [
                                    /*#__PURE__*/ _jsx(SignIn.KakaoButton, {
                                        type: "SIGNIN",
                                        onKakao: onKakao
                                    }),
                                    /*#__PURE__*/ _jsx(SignIn.PhoneButton, {
                                        type: "SIGNIN"
                                    })
                                ]
                            }),
                            !isPartnerLogin && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(Divider, {
                                        children: /*#__PURE__*/ _jsx(Typography, {
                                            variant: "bold12",
                                            color: theme.palette.text.disabled,
                                            children: "또는"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(SignIn.WhaleButton, {})
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(ButtonInTypography, {
                                variant: "regular14",
                                color: theme.palette.text.secondary,
                                sx: {
                                    gap: "8px"
                                },
                                children: [
                                    isPartnerLogin ? "쏠북 저자가 아니신가요?" : "쏠북에 처음 오셨나요?",
                                    /*#__PURE__*/ _jsx(Button, {
                                        variant: "strokeSecondary",
                                        className: "sign-up-btn",
                                        label: /*#__PURE__*/ _jsxs(ButtonInTypography, {
                                            variant: "semibold14",
                                            color: theme.palette.text.secondary,
                                            sx: {
                                                gap: "4px"
                                            },
                                            onClick: isPartnerLogin ? ()=>{
                                                window.open("https://promotion.solvook.com/apply/author");
                                            } : ()=>{
                                                //mx-122
                                                mixpanelEvent("Sign Up Button Clicked");
                                                redirectAgain("".concat(REGISTRATION_PAGE));
                                            },
                                            children: [
                                                isPartnerLogin ? "저자 신청" : "회원가입",
                                                /*#__PURE__*/ _jsx(Icon, {
                                                    icon: ArrowRight,
                                                    size: Sizes.smallHalf,
                                                    color: theme.palette.text.secondary
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ConfirmDialog, {
                open: isOpenSignUpDialog,
                onOpenChange: (open)=>{
                    if (!open) setState("isOpenSignUpDialog", false);
                },
                severity: openSignUpDialogContents.severity === "success" ? "success" : openSignUpDialogContents.severity === "caution" ? "default" : "error",
                title: openSignUpDialogContents.title,
                description: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        openSignUpDialogContents.content,
                        /*#__PURE__*/ _jsx(ChannelHintBox, {
                            maskedPhone: openSignUpDialogContents.maskedPhone,
                            maskedEmail: openSignUpDialogContents.maskedEmail
                        })
                    ]
                }),
                confirmText: openSignUpDialogContents.btnLabel || "확인",
                onConfirm: ()=>{
                    var _openSignUpDialogContents_onOk;
                    (_openSignUpDialogContents_onOk = openSignUpDialogContents.onOk) === null || _openSignUpDialogContents_onOk === void 0 ? void 0 : _openSignUpDialogContents_onOk.call(openSignUpDialogContents);
                    setState("isOpenSignUpDialog", false);
                }
            })
        ]
    });
};
LoginNextPage.getLayout = (page)=>{
    return /*#__PURE__*/ _jsx(MemberPageLayout, {
        children: page
    });
};
const LoginNextPageWrapper = muiStyled("div")((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        height: "100%",
        minHeight: "752px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        h1: {
            fontSize: "40px",
            fontWeight: "bold",
            marginBottom: "64px",
            "@media (max-width: 1200px)": {},
            "@media (max-width: 768px)": {}
        }
    };
});
export const InnerBox = muiStyled("div")((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        ".sing-in-btn-box": {
            position: "relative",
            display: "flex",
            flexDirection: "column",
            gap: "12px"
        },
        ".sign-up-btn": {
            height: "24px",
            padding: "2px 8px",
            gap: "4px"
        }
    };
});
export const ButtonInTypography = muiStyled(Typography)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    };
});
export default LoginNextPage;
